module.exports = __webpack_public_path__ + "static/media/pour-femme-intense-big.6e97979d.png";